/**
 * Note that this file is used by a few MDS components, so ensure no other imports are added.
 */

export const ZIndex = {
  SidebarOffscreenBackground: -200,
  HeadsUpFloatingButton: 2,
  SidebarMemItOverlay: 3,
  Shadow: 5,
  FloatingButton: 30,
  QueueDebugInfo: 40,
  MentionsMenu: 45,
  StandardModal: 50,
  QuickSearchModel: 50,
  NavBar: 50,
  FloatingNotePreview: 60,
  FloatingBar: 60,
  InterstitialOverlay: 70,
  Dropdown: 100,
  HoverCard: 100,
  Sidebar: 120,
  FloatingTooltip: 200,
  OnboardingOverlay: 400,
  ToastNotification: 500,
  FloatingActions: 550,
  SourcesPreview: 505,
  FloatingActionsDropdown: 510,
  // This is their default z-index, for reference.
  ReactAriaPopover: 100_000,
  AppVersionNotice: 150_000,
  ScreenOverlay: 200_000,
  AppStoreCrashNotice: 300_000,
  // These need to be higher than everything else.
  DesktopMenuOverlay: 400_000,
  DebugOverlay: 500_000,
};
